module.exports = __webpack_public_path__ + "static/versa-lift-60-80-1885a3baeb29b810a95fa48be3c9e4c5.jpg";